import { string } from "fp-ts";
import { seeks } from "fp-ts/lib/Store";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { $CombinedState } from "redux";
import { Skeleton } from "../Skeleton/component";
import "./default.module.scss";

const CURRENTPAGE_SESSIONPARAM = "fa_plp_currentPage";

export interface ProductListItem {
	upc: string;
	model: string;
	moco: string;
	modelName: string;
	polarLabel: string;
	hasPrescription: boolean;
	listPrice: string;
	badgegrp1: string;
	badgegrp1icon: string;
	badgegrp2: string;
	badgegrp3: string;
	colorCount: number;
	productImage?: string;
	productImageHover?: string;
	colorName: string;
	
}

interface ProductListOpt {
	items: ProductListItem[];
	itemsPerPage?: number;
	total: number;
	detailFunction: (upcs: string[]) => Promise<any>;
	imgPath: string;
	goToPdp: (product: ProductListItem) => void;
	buffer?:number
}

const getLocalStoragePagination = () => {
	let savedPage = localStorage.getItem(CURRENTPAGE_SESSIONPARAM);
	if (savedPage) {
		return parseInt(savedPage);
	}
	return 1;
};

const printBadge = (attributes) => {
	let seenOnBadgeValue;
	let mostPopularBadgeValue;
	let trendingNowBadgeValue;
	let limitedEditionBadgeValue;
	let exclusiveBadgeValue;
	let newReleasesBadgeValue;
	let onSaleBadgeValue;
	let genderBadgeValue;
	let polarizedBadgeValue;
	let showedProductColor;

	let group1IconSrc;
	let group1BadgeValue;
	let group2BadgeValue;
	let group3BadgeValue;

	attributes.forEach((attr) => {
		switch (attr.identifier) {
			case "TEMPLE_COLOR":
				showedProductColor = attr.values[0].identifier == "True";
				break;
			case "SEEN ON":
				seenOnBadgeValue = attr.values[0].identifier;
				break;
			case "MOST POPULAR":
				mostPopularBadgeValue = attr.values[0].identifier == "True";
				break;
			case "TRENDING NOW":
				trendingNowBadgeValue = attr.values[0].identifier == "True";
				break;
			case "LIMITED_EDITION":
				limitedEditionBadgeValue = attr.values[0].identifier == "True";
				break;
			case "EXCLUSIVE":
				exclusiveBadgeValue = attr.values[0].identifier == "True";
				break;
			case "NEWRELEASES":
				newReleasesBadgeValue = attr.values[0].identifier == "True";
				break;
			case "ONSALE":
				onSaleBadgeValue = attr.values[0].identifier == "True";
				break;
			case "GENDER":
				genderBadgeValue = attr.values[0].identifier;
				break;
			case "POLARIZED":
				polarizedBadgeValue = attr.values[0].identifier == "True";
				break;
		}
		if (mostPopularBadgeValue) {
			//@ts-ignore
			group1BadgeValue = window.mostPopularProperty;
			group1IconSrc = "/wcsstore/VogueSAS/images/svg/badge_popular.svg";
		} else if (seenOnBadgeValue && seenOnBadgeValue != "") {
			//@ts-ignore
			group1BadgeValue = window.seenOnProperty.replace("{0}", seenOnBadgeValue);
			group1IconSrc = "/wcsstore/VogueSAS/images/svg/badge_seenon.svg";
		} else if (trendingNowBadgeValue) {
			//@ts-ignore
			group1BadgeValue = window.trendingNowProperty;
			group1IconSrc = "/wcsstore/VogueSAS/images/svg/badge_trending.svg";
		}
	});

	if (limitedEditionBadgeValue) {
		//@ts-ignore
		group2BadgeValue = window.soldOutProperty;
	} else if (onSaleBadgeValue) {
		//@ts-ignore
		group2BadgeValue = window.onSaleProperty;
	} else if (limitedEditionBadgeValue) {
		//@ts-ignore
		group2BadgeValue = window.limitedEditionProperty;
	} else if (exclusiveBadgeValue) {
		//@ts-ignore
		group2BadgeValue = window.exclusiveProperty;
	} else if (newReleasesBadgeValue) {
		//@ts-ignore
		group2BadgeValue = window.newReleasesProperty;
	}

	if (genderBadgeValue == "Junior" || genderBadgeValue == "Kids") {
		//@ts-ignore
		group3BadgeValue = "#" + window.genderKidsProperty;
	} else if (polarizedBadgeValue) {
		//@ts-ignore
		group3BadgeValue = "#" + window.polarizedProperty;
	}

	return {
		group1IconSrc: group1IconSrc,
		group1BadgeValue: group1BadgeValue,
		group2BadgeValue: group2BadgeValue,
		group3BadgeValue: group3BadgeValue,
	};
};

export function ProductList({
	items,
	total,
	detailFunction,
	imgPath,
	itemsPerPage = isMobile ? 8 : 20,
	goToPdp,
	buffer
}: ProductListOpt) {
	const [paginatedList, setPaginatedList] = useState([]);
	const [currentPage, setCurrentPage] = useState(getLocalStoragePagination());
	const [skeletonNumber, setSkeletonNumber] = useState(0);
	//const [isLastPage, setIsLastPage] = useState(false);

	const paginate = (
		array: any[],
		page_size: number,
		page_number: number,
		bufferC?: number
	) => {
		//return array.slice(0, page_number * page_size/*  + page_size */);
		let ret = [];
		let bufferSize = bufferC || 0;

		if (array) {
			for (let i = 0; i < page_size * page_number + bufferSize; i++) {
				if (array[i]) {
					ret.push(array[i]);
				} 
			}
		}
		return ret;
	};

	useLayoutEffect(() => {
		const filters = document.querySelectorAll(".toggle__item");
		if (filters) {
			filters.forEach((item) => {
				item.setAttribute("tabindex", "0");
			});
		}
		const glassFilter = document.querySelector(".glass-filters");
		if (glassFilter) {
			try {
				//@ts-ignore
				$(glassFilter).unstick();
			} finally {
				//@ts-ignore
				$(glassFilter).sticky({
					responsiveWidth: true,
					topSpacing: document.querySelector(".header").getBoundingClientRect()
						.bottom,
					zIndex: 15,
					className: "glass-filter-sticky",
					center: "true",
				});
			}
		}
	});

	useEffect(() => {
		if (items) {
			let paginated = paginate(items, itemsPerPage, currentPage, buffer);
			if (paginated) {
				const recordToShow = itemsPerPage * currentPage;
				const skeletonToshow =
					total - recordToShow > itemsPerPage
						? itemsPerPage
						: total - recordToShow;
				setSkeletonNumber(skeletonToshow);
				detailFunction(paginated.map((prod) => prod.moco))
					.then((data) => {
						if (data) {
							const mappedProducts = paginate(
								paginated.filter((pitem) =>
									data.some((p) => pitem.moco === p.partNumber)
								),
								itemsPerPage,
								currentPage
							).map((prodMap: ProductListItem) => {
								const prod = data.find((p) => prodMap.moco === p.partNumber);
								if (prod && prod.attributes) {
									// console.log(prod.attributes)
									//modelName
									const searchModelName = prod.attributes.find(
										(attr) =>
											attr.identifier === "MODELNAME" &&
											attr.usage === "Descriptive"
									);
									if (searchModelName) {
										prodMap.modelName = searchModelName.values[0].value;
									}
									//polar
									const searchPolar = prod.attributes.find(
										(attr) =>
											attr.identifier === "POLARIZED" &&
											attr.usage === "Descriptive"
									);
									if (searchPolar) {
										const checkIsPolarConfirmed = searchPolar.values.find(
											(val) =>
												val.value == true || val.value.toLowerCase() === "yes"
										);
										if (checkIsPolarConfirmed) {
											prodMap.polarLabel = searchPolar.name;
										}
									}
									//prescription
									const searchPrescription = prod.attributes.find(
										(attr) => attr.identifier === "IS_ROXABLE"
									);
									if (searchPrescription) {
										const checkIsPrescriptionConfirmed =
											searchPrescription.values.find(
												(val) =>
													val.values == true ||
													val.value.toLowerCase() === "yes"
											);
										if (checkIsPrescriptionConfirmed) {
											prodMap.hasPrescription = true;
										}
									}

									//badge
									const badgeT = printBadge(prod.attributes);

									prodMap.badgegrp1 = badgeT.group1BadgeValue;
									prodMap.badgegrp1icon = badgeT.group1IconSrc;
									prodMap.badgegrp2 = badgeT.group2BadgeValue;
									prodMap.badgegrp3 = badgeT.group3BadgeValue;

									//list price
									//@ts-ignore
									prodMap.listPrice = WCCurrencyJS.format(
										//@ts-ignore
										getPriceByCustomerSegment(prod["price"])
									);

									//colorCount

									prodMap.colorCount = 1;

									const frontCOlorFind = prod.attributes.find(
										(attr) => attr.identifier === "FRONT_COLOR"
									);
									prodMap.colorName = null;
									if (frontCOlorFind && frontCOlorFind.values) {
										prodMap.colorName = frontCOlorFind.values[0].value;
									}

									prodMap.productImage =
										prod.fullImage
											.replace("_fr", "_qt")
											.replace("_shad_qt_clipon", "_shad_qt")
											.replace("&bg=f7f7f7", "") + "&bg=f8f8fb";
									prodMap.productImageHover =
										prod.fullImage
											.replace("__001", "__002")
											.replace("_fr", "_qt")
											.replace("_shad_qt_clipon", "_shad_qt")
											.replace("&bg=f7f7f7", "") + "&bg=f8f8fb";
								}

								return prodMap;
							});
							setPaginatedList(mappedProducts);
						}
					})
					.catch((error) => {
						console.log("error test", error);
					})
					.finally(() => {
						setTimeout(() => {
							setSkeletonNumber(null);
							reloadHeight();
						}, 1500);
					});
			}
		}
	}, [itemsPerPage, currentPage, items]);

	const loadMore = () => {
		localStorage.setItem(
			CURRENTPAGE_SESSIONPARAM,
			(currentPage + 1).toString()
		);
		setCurrentPage(currentPage + 1);
	};

	const getIndex = (index) => {
		let val = 0;
		for (let i = 0; i <= index; i++) {
			if (val === 4) {
				val = 0;
			}
			val++;
		}
		return val;
	};

	const getRow = (index) => {
		if (index % 3 <= 1) {
			return 1;
		}
		return 2;
	};

	const handleClick = (product) => {
		if (goToPdp) {
			goToPdp(product);
		}
	};

	const reloadHeight = () => {
		//@ts-ignore
		const lastChildBottom = //@ts-ignore
			$(".ProductList__listBox").children().last().height() + //@ts-ignore
			$(".ProductList__listBox").children().last().position().top;
		//@ts-ignore
		const listTop = $(".ProductList__listBox").position().top;
		//@ts-ignore
		const bufferHeight = isMobile ? 0 : 200;

		const heightToSet = lastChildBottom - listTop;
		//@ts-ignore
		$(".ProductList__listBox").height(heightToSet + bufferHeight);
	};
	const ariaAcyion = { area_element: "action" };

	if(!items) return null;

	return (
		<>
			<div className="ProductList__container">
				<div className={"ProductList__listBox"}>
					{paginatedList
						? paginatedList.map((product: ProductListItem, index: number) => {
								return (
									<div
										{...ariaAcyion}
										data-description={
											"Oliver_" + product.modelName + "_" + product.upc
										}
										data-element-id={"Tiles_Tile" + (index + 1)}
										area-element="action"
										style={{ cursor: "pointer" }}
										onClick={() => handleClick(product)}
										tabIndex={0}
										key={product.upc + "_" + product.moco + "_" + index}
										className="ProductList__listBox__card"
									>
										<div className="badgegrp1-wrapper">
											<img
												className="badgegrp1-icon"
												src={product.badgegrp1icon}
											/>
											<p className="badgegrp1-label">{product.badgegrp1}</p>
										</div>
										<div
											className="ProductList__listBox__card_overlay"
											data-col={getIndex(index)}
											data-row={getRow(index)}
										>
											<span
												style={
													!product.badgegrp2 || !product.badgegrp2.length
														? { opacity: 0 }
														: null
												}
												className="ProductList__listBox__card_lbl_mostpopular"
											>
												{product.badgegrp2 || "placeholder"}
											</span>
											<span className="ProductList__listBox__card_lbl_sub">
												low bridge
											</span>
											<span className="ProductList__listBox__card_lbl_model">
												{product.modelName || product.upc}{" "}
												<span className="badgegrp3-label">
													{product.badgegrp3}
												</span>
											</span>
											<span className="ProductList__listBox__card_lbl_sub">
												{product.moco}
											</span>

											<div className="ProductList__listBox__card_imgBox">
												<img
													src={product.productImage}
													className="product_img"
												/>
												<img
													src={product.productImageHover}
													className="product_hover"
												/>
											</div>

											{product.polarLabel && (
												<div className="ProductList__listBox__card_polaricon">
													<span>{product.polarLabel}</span>
												</div>
											)}
											<div
												className="ProductList__listBox__card_price"
												style={
													!product.listPrice || !product.listPrice.length
														? { opacity: 0 }
														: null
												}
											>
												{product.listPrice || "placeholder"}
											</div>
											{product.colorCount && (
												<div className="ProductList__listBox__card_footerdesc">
													{product.colorName
														? product.colorName
														: product.colorCount + " Colors"}
												</div>
											)}
											<div
												className="ProductList__listBox__card_footersub"
												dangerouslySetInnerHTML={{
													__html: product.hasPrescription
														? "Prescription avaiable"
														: "&nbsp;",
												}}
											></div>
										</div>
									</div>
								);
						  })
						: null}
				</div>

				{skeletonNumber ? <Skeleton cardNumber={skeletonNumber} /> : null}
			</div>
			{items && (itemsPerPage * currentPage)<=items.length ? (
				<button
					{...ariaAcyion}
					data-element-id={"Tiles_LoadMore"}
					area-element="action"
					className="ProductList__loadMore_btn"
					onClick={loadMore}
				>
					load more
				</button>
			) : null}
		</>
	);
}

//baseUrl + this.partNumber.replaceAll('_','-').replaceAll('/', '-');

/*
modelName: modelNameValue != undefined ? modelNameValue : '',
        inventoryStatus: inventoryStatus,
        image: function () {
            if (isOliver){
                // OP: using of OV_OpPlp
                return showedProduct.thumbnail+'&bg=f8f8fb';
            } else  {
                // PO: scaling of 45% on desktop
                //return showedProduct.thumbnail.replace('sclw=0.25&sclh=0.25','sclw=0.45&sclh=0.45');
                return replaceTileImgByDevice(showedProduct.thumbnail,'sclw=0.25&sclh=0.25','small');
            }
        },
        imageScaled: function () {
            if (isOliver){
                // OP: scaling of 25% on mobile
                return showedProduct.thumbnail.replace('OV_OpPlp','OV_parameters&sclw=0.25&sclh=0.25')+'&bgcolor=%23f8f8fb';
            } else  {
                // PO: scaling of 25% on mobile
                //return showedProduct.thumbnail;
                return replaceTileImgByDevice(showedProduct.thumbnail,'sclw=0.25&sclh=0.25','small');
            }
        },
        thumbnail: function () {
            if (isOliver){
                return showedProduct.thumbnail+'&bgcolor=%23f8f8fb';
            } else
                //return attr.thumbnail;
                return replaceTileImgByDevice(showedProduct.thumbnail,'sclw=0.25&sclh=0.25','lowerCarousel');
        },
        uniqueID: showedProduct != undefined ? showedProduct.uniqueID : '',
        partNumber: (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() ? model : model[indexOtherColors]).partNumber,
        partNumberAlt: function () {
            return this.partNumber.replaceAll('_','-').replaceAll('/', '-');
        },
        numberColors: getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() ? 1 : model.length,
        colorProperty: !(getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile()) && model.length > 1 ? colorsProp : colorProp,
        offerPrice: offerPrice ? WCCurrencyJS.format(offerPrice) : '',
        listPrice: listPrice ? WCCurrencyJS.format(listPrice) : '',
        percentage: percentage,
        baseURL: WCParamJS.homePageURL,
        isPolar: isPolar,
        group2BadgeValue: group2BadgeValue,
        otherColorsNotMain: getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() ? [] : model.slice(1,model.length), //returns the array minus the 1st element
        otherColors: getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() ? [ model ] : model,
        replaceImageUrl: function () {
            if (this.thumbnail != undefined) {
                if (isOliver){
                    // OP: using of OV_OpPlp
                    if (isClipon) {
                        //return this.thumbnail.replace('/extra/image/OliverPeoples/clipon','/is/image/OliverPeoples').replace('_shad_fr_clipon','_shad_qt')+'&bg=f8f8fb';
                        return this.thumbnail+'&bg=f8f8fb';
                    }
                    return this.thumbnail.replace('__001','__002').replace('_fr','_qt').replace('_shad_qt_clipon','_shad_qt')+'&bg=f8f8fb';
                } else {
                    // PO: scaling of 45% on desktop
                    //return this.thumbnail.replace('_fr','_qt').replace('_001','_002').replace('sclw=0.25&sclh=0.25','sclw=0.45&sclh=0.45');
                    return replaceTileImgByDevice(showedProduct.thumbnail.replace('_fr','_qt').replace('_001','_002'),'sclw=0.25&sclh=0.25','small');
                }
            }
            return this.thumbnail;
        },
        replaceImageUrlScaled: function () {
            if (this.thumbnail != undefined) {
                if (isOliver){
                    // OP: scaling of 25% on mobile
                    if (isClipon) {
                        //return this.thumbnail.replace('/extra/image/OliverPeoples/clipon','/is/image/OliverPeoples').replace('_shad_fr_clipon','_shad_qt').replace('OV_OpPlp','OV_parameters&sclw=0.25&sclh=0.25')+'&bg=f8f8fb';
                        return this.thumbnail.replace('OV_OpPlp','OV_parameters&sclw=0.25&sclh=0.25')+'&bgcolor=%23f8f8fb';
                    }
                    return this.thumbnail.replace('__001','__002').replace('_fr','_qt').replace('_shad_qt_clipon','_shad__qt').replace('OV_OpPlp','OV_parameters&sclw=0.25&sclh=0.25')+'&bgcolor=%23f8f8fb';
                } else {
                    // PO: scaling of 25% on mobile
                    //return this.thumbnail.replace('_fr','_qt').replace('_001','_002');
                    return replaceTileImgByDevice(showedProduct.thumbnail.replace('_fr','_qt').replace('_001','_002'),'sclw=0.25&sclh=0.25','small');
                }
            }
            return this.thumbnail;
        },
        replaceImageUrl1Tile: function () {
            if (this.thumbnail != undefined) {
                if (isOliver){
                    return this.thumbnail.replace('OV_OpPlp','OV_parameters&sclw=0.25&sclh=0.25')+'&bgcolor=%23f8f8fb';
                } else
                    //return this.thumbnail;
                    return replaceTileImgByDevice(showedProduct.thumbnail,'sclw=0.25&sclh=0.25','big');
            }
            return this.thumbnail;
        },
        index: function() {
            indexOtherColors++;
        },
        checkifFirst: function() {
            return indexOtherColors === 0;
        },
        // Show color names under image
        printColorsName: function(){
            $(this.attributes).each(function (){
                if ((this.identifier) === "FRONT_COLOR"){
                     eachFrontColor = ((this).values[0].value);
                }
                if ((this.identifier) === "LENS_COLOR"){
                              eachLensColor = ((this).values[0].value);
                }
            })
            if ($("#categoryName").val() === 'OV_Sun') {
                return (eachFrontColor + '/' + eachLensColor);
            } else {
                return (eachFrontColor);
            }
        },
        printClassBadge: function() {
            if(isPersol){
                var promo = calculatePromo(this)
                if(promo) return "orange-badge";
            }
            return printBadges(this.attributes, true);
        },
        printBadge: function() {
            if(isPersol){
                var promo = calculatePromo(this)
                if(promo) return promo;
            }
            return printBadges(this.attributes, false);
        },
        printListPrice: function() {
            var product = this;
            var listPrice =  product['price']['listprice'] ? product['price']['listprice'] : "";
            return listPrice != '' ? WCCurrencyJS.format(listPrice) : MESSAGE_NO_PRICE_AVAILABLE;
        },
        printOfferPrice: function() {
            var product = this;
            var offerPrice = product['price']['price'] ? product['price']['price'] : "";
            return offerPrice != '' ? WCCurrencyJS.format(offerPrice) : MESSAGE_NO_PRICE_AVAILABLE;
        },
        printStatus: function() {
            return printStatus(this);
        },
        checkisPolar: function() {
            return getPolarized(this.attributes, true);
        },
        printPolarBadge: function() {
            return getPolarized(this.attributes);
        },
        checkisFoldable: function() {
            return getFoldable(this.attributes, true);
        },
        printFoldable: function() {
            return getFoldable(this.attributes);
        },
        isPrescription: function(){
            return isPrescription(this.attributes);
        }

*/
